import { getABNVariant } from '~/src/helpers/abn-tests';

export const connectionWithStopper = () => getABNVariant('pop-up_connection') === 'pop-up_connection_with_stopper';
